import SelectSearch from '../../../Core/Fields/Floating/SelectSearch';

const Tab2 = ({ formData, handleChange, errors }) => {
  const Sno = [
    { name: "Manual" },
    { name: "System Generated" }
  ];
  
  return (
    <>
      <div className="row mb-3" style={{ border: "1px solid #00000059", borderRadius: "5px" }}>
        <div className="col-12">
          <p className="boxLabel m-0">Serial No Setup</p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <SelectSearch
              list={Sno}
              label="Serial No"
              getOptionLabel={(item) => item.name}
              getOptionValue={(item) => item.name}
              value={formData.serialNoSetup}
              onChange={(val) => handleChange('serialNoSetup', val)}
              error={errors?.serialNoSetup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Tab2;